import type { UserInfoUpdateRequestAPI } from './ApiTypes';

interface BuildUserInfoChangesInput {
  initialName: string;
  initialPhone: string;
  nextName: string;
  nextPhone: string;
}

/**
 * Builds the `changes` payload for POST /account/update.
 * - Omits keys for fields that did not change.
 * - Sends `phone_number` already normalized to E.164 BR.
 */
export const buildUserInfoChanges = ({ initialName, initialPhone, nextName, nextPhone }: BuildUserInfoChangesInput): UserInfoUpdateRequestAPI['changes'] => {
  const changes: UserInfoUpdateRequestAPI['changes'] = {};
  if (nextName !== initialName) changes.fullname = nextName;
  if (nextPhone !== initialPhone) changes.phone_number = nextPhone;
  return changes;
};
